// project imports
import DateObject from 'react-date-object';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import persian_en from 'react-date-object/locales/persian_en';
import gregorian from 'react-date-object/calendars/gregorian';
import gregorian_en from 'react-date-object/locales/gregorian_en';

// ===============================|| Date ||=============================== //

export const ConvertDate = (date, format = 'YYYY/MM/DD', options = {}) => {
    return new DateObject({
        date: date,
        calendar: persian,
        locale: persian_fa,
        ...options
    }).format(format);
};

export default ConvertDate;

export const GregorianDate = (date, format = 'YYYY/MM/DD') => {
    return new DateObject({
        date: date,
        calendar: persian,
        locale: persian_en
    })
        .setCalendar(gregorian)
        .format(format);
};

export const PersianDate = (date, format = 'YYYY/MM/DD') => {
    return new DateObject({
        date: date,
        calendar: gregorian,
        locale: gregorian_en
    })
        .setCalendar(persian)
        .format(format);
};

// Next pay date
export const NextPayDate = (periodType, periodDay, remainDays) => {
    const newDate = NextPayDateGreg(remainDays);
    let format = periodType.toLowerCase() != 'month' ? 'YYYY/MM/DD' : 'YYYY/MM/' + ('0' + periodDay).slice(-2);
    let nextPayDate = '';
    if (1 /* shamsi */) {
        if (periodType.toLowerCase() == 'month') format = 'YYYY/MM/' + ('0' + GregDayToPersianDay(newDate, periodDay)).slice(-2);
        const shamsi = ConvertDate(newDate, format);
        nextPayDate = String(shamsi);
    } else {
        nextPayDate = String(newDate.format(format));
    }

    return nextPayDate;
};

// Next pay date
export const NextPayDateGreg = (remainDays) => {
    const date = new Date();
    return new Date(date.setDate(date.getDate() - parseInt(remainDays)));
};

export const PersianDayToGregDay = (date, day) => {
    try {
        const persianDate = PersianDate(date, 'YYYY/MM/DD').substring(0, 8) + day;
        return parseInt(GregorianDate(persianDate, 'YYYY/MM/DD').substring(8, 10));
    } catch (error) {
        return 0;
    }
};

export const GregDayToPersianDay = (date, day) => {
    try {
        const gregDate = new DateObject(date).format('YYYY/MM/DD').substring(0, 8) + day;
        return parseInt(PersianDate(gregDate, 'YYYY/MM/DD').substring(8, 10));
    } catch (error) {
        return 0;
    }
};

export { DateObject };
